// import Amplify from "@aws-amplify/core";
// import Analytics from "@aws-amplify/analytics";
// import "@aws-amplify/auth";

import aws_exports from '../aws-exports.0'
/* eslint-disable */
import { getItemStorage } from '@/plugins/util'
import { pick } from '../plugins/lodash'
import { LOCAL_STORAGE_KEY__USER, LOCAL_STORAGE_KEY__FINGERPRINT } from '@/mixins/constants'

var Amplify, Analytics
var loadAmplifyPromise = new Promise((resolve) => {
  import(
    /* webpackPrefetch: true */
    '@aws-amplify/core'
  ).then((loaded_module) => {
    Amplify = loaded_module.default
    resolve()
  })
})

var loadAnalyticsPromise = new Promise((resolve) => {
  import(
    /* webpackPrefetch: true */
    '@aws-amplify/analytics'
  ).then((loaded_module) => {
    Analytics = loaded_module.default
    resolve()
  })
})
var loadAuthPromise = new Promise((resolve) => {
  import(
    /* webpackPrefetch: true */

    '@aws-amplify/auth'
  ).then(() => {
    resolve()
  })
})

Promise.all([loadAmplifyPromise, loadAnalyticsPromise, loadAuthPromise]).then(() => {
  Amplify.configure(
    Object.assign(aws_exports, {
      autoSessionRecord: false,
      mandatorySignIn: false
    })
  )

  if (shouldTrackEvent()) {
    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          pinpointStopSession()
        } else {
          pinpointStartSession()
        }
      },
      { passive: true }
    )
    window.addEventListener(
      'beforeunload',
      () => {
        pinpointStopSession()
      },
      { passive: true }
    )
  }
})
// window.LOG_LEVEL='DEBUG'

const shouldTrackEvent = () => {
  return process.env.VUE_APP_ENABLE_TRACKING_EVENT === 'true'
}
const globalPinPointAttrs = {
  platform: 'web'
}
const getGlobalPinPointAttributes = () => {
  if (globalPinPointAttrs.user_id) return globalPinPointAttrs
  const currentUser = JSON.parse(getItemStorage(LOCAL_STORAGE_KEY__USER)) || {}
  const fingerprint = getItemStorage(LOCAL_STORAGE_KEY__FINGERPRINT)
  if (currentUser) {
    const { _id, city_id } = currentUser
    let imeiWeb
    if (currentUser.devices && currentUser.devices.length > 0) {
      const web = currentUser.devices.find((item) => item.type === 'web')
      imeiWeb = web && web.imei
    }
    Object.assign(globalPinPointAttrs, {
      city_id: (city_id && city_id[0]) || '',
      user_id: _id,
      device_id: fingerprint || imeiWeb,
      user_agent: navigator.userAgent
    })
  }
  return globalPinPointAttrs
}

export const pinpointStartSession = () => {
  const globalAttrs = getGlobalPinPointAttributes()
  const eventTimestamp = String(Date.now())

  try {
    Analytics &&
      Analytics.record({
        name: '_session_start',
        attributes: {
          ...globalAttrs,
          event_type: 'Session_start',
          event_timestamp: eventTimestamp,
          type_of_start_session: 'open_app'
        }
      })

    console.log('pinpointStartSession recorded successfully')
  } catch (e) {
    console.error('Error recording event:', e)
  }
}

export const pinpointStopSession = () => {
  const globalAttrs = getGlobalPinPointAttributes()
  const eventTimestamp = String(Date.now())

  try {
    Analytics &&
      Analytics.record({
        name: '_session_stop',
        attributes: {
          ...globalAttrs,
          event_type: 'Session_end',
          event_timestamp: eventTimestamp,
          type_of_start_session: 'close_app'
        }
      })

    console.log('pinpointStopSession recorded successfully')
  } catch (e) {
    console.error('Error recording event:', e)
  }
}

export const logEvent = function (gaAction, eventName, amplData = {}, gaValue, pinpointData = {}) {
  /* eslint-disable */
  try {
    setTimeout(() => {
      // console.log('Analytic: ', Analytics)
      if (shouldTrackEvent()) {
        window.dataLayer.push({
          event: 'custom_event',
          ampEventName: eventName,
          ampEventProps: {
            ...amplData,
            ...pinpointData
          },
          gaEventCategory: window.location.pathname,
          gaEventAction: gaAction,
          gaEventLabel: eventName,
          gaEventValue: gaValue
        })
        const globalAttrs = getGlobalPinPointAttributes()
        // try {
        //   Analytics && Analytics.record({
        //     name: eventName,
        //     attributes: {
        //       ...pinpointData,
        //       ...globalAttrs
        //     }
        //   });
        // } catch (e) {}
      }
    }, 0)
  } catch (error) {
    console.log('TRACKING ERROR: ', error)
  }
  /* eslint-enable */
}

export const logIdentify = function (user) {
  /* eslint-disable */
  try {
    // send user info to GTM
    if (shouldTrackEvent()) {
      const { _id, name, email, city_id, login_with } = user

      let imeiWeb
      if (user.devices && user.devices.length > 0) {
        const web = user.devices.find((item) => item.type === 'web')
        imeiWeb = web && web.imei
      }

      /* eslint-enable */
      window.dataLayer.push({
        event: 'UserInit',
        userProfile: {
          _id,
          name,
          email,
          city_id,
          login_with,
          app_version: __APP_VERSION__ || ''
        }
      })

      // try {
      //   Analytics && Analytics.updateEndpoint({
      //     location: {
      //       city: city_id[0]
      //     },
      //     attributes: {
      //       city_id: city_id,
      //       user_id: [_id],
      //       device_id: [imeiWeb]
      //     },
      //     demographic: {
      //       platform: "web"
      //     }
      //     // ,
      //     // userAttributes: {
      //     // 	_id: [_id],
      //     // 	name: [name],
      //     // 	email: [email],
      //     // 	city_id: city_id,
      //     // 	login_with: [login_with]
      //     // }
      //   });
      // } catch (e) {}
    }
  } catch (error) {
    console.log(error)
  }
}

export const logPurchase = function (data, eventName) {
  /* eslint-disable */
  try {
    if (shouldTrackEvent()) {
      window.dataLayer.push({
        event: 'Purchase',
        value: data.final_total_pay,
        currency: 'VND',
        content_ids: [data.order_id],
        content_type: 'product',
        transactionId: data.order_id,
        transactionTotal: data.final_total_pay,
        transactionShipping: data.distance_fee
      })
      logEvent('click', eventName, data.order_detail, undefined, {
        order_id: data.order_id
      })
    }
  } catch (err) {}
  /* eslint-enable */
}

export const checkShowSurvey = function () {
  /* eslint-disable */
  try {
    if (shouldTrackEvent()) {
      window.dataLayer.push({
        event: 'CompleteOrder'
      })
      logEvent('click', eventName, data.order_detail)
    }
  } catch (err) {}
  /* eslint-enable */
}

export const getOrderTrackingData = (order) => {
  const trackingFields = [
    '_id',
    'create_time',
    'status',
    'path',
    'requests',
    'distance',
    'discount',
    'payment_method',
    'service_id',
    'total_fee',
    'total_pay',
    'promo_code'
  ]
  let trackingData = pick(order, trackingFields)
  const cleanPath = []
  trackingData.path &&
    trackingData.path.forEach((point) => {
      const cleanPoint = pick(point, ['lat', 'lng', 'address', 'shipping_type'])
      cleanPath.push(cleanPoint)
    })
  trackingData.path = JSON.stringify(cleanPath)
  return trackingData
}

/**
 *
 * @param {string} eventType // EVENTS
 * @param {Object} eventParameters
 */
export const trackEvent = (eventType, eventParameters = {}) => {
  try {
    const globalAttrs = getGlobalPinPointAttributes()
    console.log(window.dataLayer && shouldTrackEvent() ? '[Tracked]' : '[Not Tracked]', eventType, {
      ...globalAttrs,
      ...eventParameters
    })

    if (window.dataLayer && shouldTrackEvent()) {
      window.dataLayer.push({
        event: 'custom_event', // Event name that will activate trigger
        eventType, // event type which would be sent to GA.
        ...globalAttrs,
        ...eventParameters
      })
    }
  } catch (error) {
    console.log('TRACKING ERROR: ', error)
  }
}
